import React from 'react';
import { View, ScrollView, StyleSheet, Platform } from 'react-native';

interface PlatformContainerProps {
  children: React.ReactNode;
  style?: any;
  showsVerticalScrollIndicator?: boolean;
}

/**
 * Platform-specific container wrapper
 * Uses ScrollView on iOS for better scrolling performance
 * Uses View on other platforms (web, Android)
 */
export const PlatformContainer: React.FC<PlatformContainerProps> = ({ 
  children, 
  style,
  showsVerticalScrollIndicator = false 
}) => {
  const containerStyle = style || styles.container;

  if (Platform.OS === 'ios') {
    return (
      <ScrollView 
        style={containerStyle} 
        showsVerticalScrollIndicator={showsVerticalScrollIndicator}
      >
        {children}
      </ScrollView>
    );
  }

  return (
    <View style={containerStyle}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F5F9FF',
    paddingVertical: 20,
    paddingHorizontal: 24,
  },
});
